import { CgUserlane } from "react-icons/cg";
import {
    IoLayers,
    IoTelescope,
    IoFastFood,
    IoHappyOutline,
    IoCodeSlash,
    IoDesktopOutline,
    IoLogoGithub,
    IoLibrary,
    IoLogoReact,
    IoRestaurant,
    IoDocumentText,
    IoHourglassOutline,
} from "react-icons/io5";

const ProjectsData = {
    projects_head_tag: "Portfolio",
    projects_head_title: "Some of my cool projects",
};

const ProjectsCardData = [
    {
        id: 1,
        project_img: "assets/projects/web1.png",
        project_alt: "Web 1",
        project_icon: <CgUserlane />,
        project_title: "Portfolio",
        project_link: "https://imniladri.in/",
        project_bg: "info info_dark",
    },
    {
        id: 2,
        project_img: "assets/projects/web2.png",
        project_alt: "Web 2",
        project_icon: <IoLayers />,
        project_title: "Projects",
        project_link: "https://imniladri.github.io/",
        project_bg: "info info_dark",
    },
    {
        id: 3,
        project_img: "assets/projects/web3.png",
        project_alt: "Web 3",
        project_icon: <IoTelescope />,
        project_title: "SAAC",
        project_link: "https://saacjgec.vercel.app/",
        project_bg: "info info_dark",
    },
    {
        id: 4,
        project_img: "assets/projects/web4.png",
        project_alt: "Web 4",
        project_icon: <IoFastFood />,
        project_title: "Food Mate",
        project_link: "https://foodmate.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 5,
        project_img: "assets/projects/web5.png",
        project_alt: "Web 5",
        project_icon: <IoHappyOutline />,
        project_title: "We Are 8",
        project_link: "https://weare8.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 6,
        project_img: "assets/projects/web6.png",
        project_alt: "Web 6",
        project_icon: <IoCodeSlash />,
        project_title: "Dev Hub",
        project_link: "https://devohub.vercel.app/",
        project_bg: "info info_dark",
    },
    {
        id: 7,
        project_img: "assets/projects/web7.png",
        project_alt: "Web 7",
        project_icon: <IoDesktopOutline />,
        project_title: "Education",
        project_link: "https://edulearn.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 8,
        project_img: "assets/projects/web8.png",
        project_alt: "Web 8",
        project_icon: <IoLogoGithub />,
        project_title: "Git Card",
        project_link: "https://gitog.vercel.app/",
        project_bg: "info info_dark",
    },
    {
        id: 9,
        project_img: "assets/projects/web9.png",
        project_alt: "Web 9",
        project_icon: <IoLibrary />,
        project_title: "A'Library",
        project_link: "https://alibrary.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 10,
        project_img: "assets/projects/web10.png",
        project_alt: "Web 10",
        project_icon: <IoLogoReact />,
        project_title: "React",
        project_link: "https://react-portfolio-imniladri.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 11,
        project_img: "assets/projects/web11.png",
        project_alt: "Web 11",
        project_icon: <IoRestaurant />,
        project_title: "Restaurant",
        project_link: "https://restora.vercel.app/",
        project_bg: "info info_dark",
    },
    {
        id: 12,
        project_img: "assets/projects/web12.png",
        project_alt: "Web 12",
        project_icon: <IoDocumentText />,
        project_title: "PDF Chest UI",
        project_link: "https://pdfchestui.vercel.app/",
        project_bg: "info info_light",
    },
    {
        id: 13,
        project_img: "assets/projects/web13.png",
        project_alt: "Web 13",
        project_icon: <IoHourglassOutline />,
        project_title: "Timescape",
        project_link: "https://timescape.vercel.app/",
        project_bg: "info info_dark",
    },
];

export { ProjectsData, ProjectsCardData };
